import React from "react";

export default function Dashboard() {
  return (
    <div className="text-dark">
      {/* project section */}
      <div>
        <h1>Project Section</h1>
      </div>
    </div>
  );
}
